import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanel from './rightPanel';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { resetMeetingRoomForm } from 'actions/meetingRoom';

export default function EditMeetingRoomPropertes(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetMeetingRoomForm());
    };
  }, []);

  let rightPanel = '';
  let centerPanel = '';
  let subtitle = props.selectedMeetingRoom.name + ' (' + props.selectedMeetingRoom.organisationAbbreviatedName + ')';

  centerPanel = (
    <CenterPanelUpdate callQualityOptions={props.callQualityOptions} meetingRoomForm={props.meetingRoomForm} />
  );

  rightPanel = <RightPanel meetingRoomForm={props.meetingRoomForm} selectedMeetingRoom={props.selectedMeetingRoom} />;

  return (
    <Modal show={true} hideWhenClickAway={true} className={props.updateOrView + '-meeting-room'}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewMeetingRoom.HelpEditMeetingRoom}
        title={APP.LANGUAGE.EditMeetingRoomProperties.Title}
        subtitle={subtitle}
      />
      <div className="content">
        <div className="main-ui-container meeting-room-create-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
